export const MAP_STYLES = [
  {
    elementType: 'geometry',
    stylers: [
      {
        color: '#15202D',
      },
    ],
  },
  {
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#626A72',
      },
    ],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#08101B',
      },
    ],
  },
  {
    featureType: 'administrative.country',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#061220',
      },
      {
        visibility: 'on',
      },
      {
        weight: 1,
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#061220',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#061220',
      },
    ],
  },
];

export const INITIAL_ZOOM_LEVEL = 5;

export const ZOOM_ON_CLICK = 5;

export const MAP_OPTIONS = {
  zoomControl: false,
  maxZoom: 15,
  disableDefaultUI: true,
  gestureHandling: 'greedy',
  scrollwheel: false,
  restriction: {
    latLngBounds: {
      north: 85.0,
      south: -85.0,
      west: -179.0,
      east: 179.0,
    },
    strictBounds: true,
  },
  styles: MAP_STYLES,
};
